module.exports = __webpack_public_path__ + "static/media/PDF.e9e78142.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PDF.svg
// module id = 669
// module chunks = 0